import {ChangeDetectionStrategy, Inject, Component, ElementRef, OnInit, ViewEncapsulation} from "@angular/core";
import {NewsService} from "../shared/news.service";
import {News} from "./news.model";

declare var $:any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'news',
  styles: [ require('./news.component.css') ],
  template: require('./news.component.html')
})
export class NewsComponent implements OnInit {

  isBrowser: boolean;
  news: News[];

  ngOnInit(): void {
    if(this.isBrowser){
      // // Get the modal
      // var modalZoom = document.getElementById('myModal-c');

      // // Get the image and insert it inside the modal - use its "alt" text as a caption
      // var imgZoom = document.getElementById('myImg');
      // var modalImgZoom = document.getElementById("img01");
      // var captionText = document.getElementById("caption");
      // imgZoom.onclick = function(){
      //     modalZoom.style.display = "block";
      //     modalImgZoom.src = this.src;
      //     captionText.innerHTML = this.alt;
      // }

      // // Get the <span> element that closes the modal
      // var span = document.getElementsByClassName("close")[0];

      // // When the user clicks on <span> (x), close the modal
      // span.onclick = function() { 
      //     modalZoom.style.display = "none";
      // }
    }


    this.newsService.getNews().subscribe(news => this.news = news);
  }

  constructor(@Inject('isBrowser') isBrowser: boolean,private newsService: NewsService){
    this.isBrowser = isBrowser;
  }

  showText(textElement: any,newsBtn: any){
    var el = $(textElement),
      curHeight = el.height(),
      autoHeight = el.css('height', 'auto').height(),
      btn = $(newsBtn);
    if(curHeight < autoHeight){
      el.height(curHeight).animate({height: autoHeight}, 500);
      // btn.delay(1).css("visibility", "hidden");
      btn.delay(1).css("display", "none");
    } else{
      el.height(curHeight).animate({height: curHeight}, 500);
      btn.delay(1).css("display", "inline-block");
      // btn.delay(1).css("visibility", "visible");
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+news/news.component.ts